<template>
  <div class="confidenceintervals hide-for-print">
    <div class="confidenceintervals__confidence">
      <Checkbox
        class="confidenceintervals__confidence__checkbox"
        :active="showConfidenceIntervals"
        @toggle="toggleConfidenceInterval()"
      >{{ this.$Strings('confidenceIntervals') }}</Checkbox>
      <HelpTooltip class="confidenceintervals__confidence__tooltip" :description="this.$Strings('confidenceIntervalsDescription')"></HelpTooltip>
    </div>
  </div>
  <!-- /.confidenceintervals -->
</template>

<script>
import HelpTooltip from './HelpTooltip.vue'
import Checkbox from './Checkbox.vue'

export default {
  name: 'confidenceintervals',
  components: { HelpTooltip, Checkbox },
  props: {
    showConfidenceIntervals: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggleConfidenceInterval () {
      this.$emit('toggleInterval', this.showConfidenceIntervals)
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/helpers';

  .confidenceintervals__confidence{
    display: flex; -js-display: flex;
    justify-content: flex-end;
    text-align: right;
  }
  .confidenceintervals__confidence__tooltip{
    display: inline-block;
    margin: 5px 0 0 7px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shared/misc/ConfidenceIntervals.vue